import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

Swiper.use([Autoplay]);

// Logo Carousel
var swiper = new Swiper(".logo-carousel .swiper", {
  slidesPerView: 2.5,
  spaceBetween: 12,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 0,
  },
  speed: 1750,
  simulateTouch: false,
  breakpoints: {
    576: {
      slidesPerView: 3.5,
    },
    768: {
      slidesPerView: 4.5,
    },
    992: {
      slidesPerView: 5.5
    },
    1200: {
      slidesPerView: 6.5
    }
  },
});

// Image Carousel
var swiper = new Swiper(".image-carousel .swiper", {
  slidesPerView: 1.25,
  spaceBetween: 12,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  grabCursor: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 42,
    },
  }
});
